import { render, staticRenderFns } from "./AttractionsList.vue?vue&type=template&id=0cb33d50"
import script from "./AttractionsList.vue?vue&type=script&lang=js"
export * from "./AttractionsList.vue?vue&type=script&lang=js"
import style0 from "./AttractionsList.vue?vue&type=style&index=0&id=0cb33d50&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb33d50')) {
      api.createRecord('0cb33d50', component.options)
    } else {
      api.reload('0cb33d50', component.options)
    }
    module.hot.accept("./AttractionsList.vue?vue&type=template&id=0cb33d50", function () {
      api.rerender('0cb33d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/AttractionsList.vue"
export default component.exports